// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1081": "5f0940749463","516": "5c0fcb8e4ba7","6651": "980c350dc741","7476": "9235748eb8a8",}[chunkId] + ".css"
}